/**
 * @fileoverview Percurso de um contato no desenho do fluxo, só para leitura.
 * Usa o mesmo nó do editor (FlowNode) e o desenho DA VERSÃO que a execução
 * usou: os nós por onde o contato passou ficam marcados, a etapa atual e a que
 * falhou também, e o resto fica apagado.
 */

import React, { useMemo } from "react";
import ReactFlow, { Background, Controls, MarkerType, ReactFlowProvider } from "react-flow-renderer";
import "react-flow-renderer/dist/style.css";
import { useTheme } from "@material-ui/core/styles";
import FlowNode from "../FlowBuilder/FlowNode";
import useBuilderStyles from "../FlowBuilder/styles";
import { nodeStatusesOf } from "./pathRules";

const nodeTypes = { flowNode: FlowNode };

const ExecutionPath = ({ version, execution }) => {
  const builderClasses = useBuilderStyles();
  const isDark = useTheme().palette.type === "dark";

  const { nodes, edges } = useMemo(() => {
    const statuses = nodeStatusesOf(execution);
    const visited = (id) => !!statuses[id];
    const strong = isDark ? "rgba(226,232,240,0.75)" : "rgba(15,23,42,0.6)";
    const faint = isDark ? "rgba(148,163,184,0.25)" : "rgba(100,116,139,0.25)";
    return {
      nodes: version.nodes.map((node) => ({
        ...node,
        draggable: false,
        selectable: false,
        connectable: false,
        style: visited(node.id) ? undefined : { opacity: 0.45 },
        data: { ...node.data, _readOnly: true, _executionStatus: statuses[node.id] },
      })),
      edges: version.edges.map((edge) => {
        const onPath = visited(edge.source) && visited(edge.target);
        const stroke = onPath ? strong : faint;
        return {
          ...edge,
          type: edge.type || "smoothstep",
          animated: false,
          style: { stroke, strokeWidth: onPath ? 2 : 1.5 },
          markerEnd: { type: MarkerType.ArrowClosed, color: stroke },
        };
      }),
    };
  }, [version, execution, isDark]);

  return (
    <div className={builderClasses.canvas}>
      <ReactFlowProvider>
        <ReactFlow
          nodes={nodes}
          edges={edges}
          nodeTypes={nodeTypes}
          fitView
          fitViewOptions={{ padding: 0.25 }}
          nodesDraggable={false}
          nodesConnectable={false}
          elementsSelectable={false}
          zoomOnScroll={false}
          panOnScroll={false}
          preventScrolling={false}
          minZoom={0.3}
        >
          <Background variant="dots" gap={20} size={1} color={isDark ? "rgba(255,255,255,0.08)" : "rgba(15,23,42,0.1)"} />
          <Controls showInteractive={false} />
        </ReactFlow>
      </ReactFlowProvider>
    </div>
  );
};

export default ExecutionPath;
